enum Routes {
  LOGIN = '/login',
  TICKET = '/ticket',
  TICKET_SEARCH = '/',
  TICKET_DETAIL = ':ticketNumber',
  VERSION = '/version',
}

export default Routes
